import BoldText from '@/components/BoldText';
import CustomBadge from '@/components/CustomBadge';
import EditorCustom from '@/components/EditorCustom';
import { FontSize } from '@/components/EditorCustom/FontSizeButton';
import { headingTextInitial, subHeadingTextInitial } from '@/constants/options';
import useLimitPlan from '@/hooks/useLimitPlan';
import userPlans from '@/hooks/userPlans';
import { handleChangePreview, previewSelector } from '@/redux/slice/preview.slice';
import { BlockStack, Card } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const TextSetting = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['popup', 'common']);
  const previewDetail = useSelector(previewSelector);
  const { isUserFreeLimited, isUserFreeOrBasicLimited } = userPlans();
  const { isShowUpgradeNowRulePopup } = useLimitPlan();

  const handleChangeTemplate = (key: keyof typeof previewDetail) => (value: string) => {
    if (key === 'headingSize' || key === 'subHeadingSize') {
      // Loại bỏ dấu '-' nếu có trong chuỗi đầu vào
      value = value.replace(/-/g, '');

      const isValidNumber = /^[0-9]\d*$/.test(value); // Chỉ cho phép số nguyên dương

      if (isValidNumber) {
        let numericValue = parseInt(value, 10);

        value = numericValue.toString();
      } else {
        value = '';
      }
    }

    dispatch(
      handleChangePreview({
        [key]: value,
      }),
    );
  };

  return (
    <BlockStack gap="200">
      <Card>
        <BlockStack gap="200">
          <BoldText>
            {t('pop_up_heading')} {isShowUpgradeNowRulePopup && <CustomBadge />}
          </BoldText>
          <EditorCustom
            value={previewDetail?.headingTextEditor ?? previewDetail?.headingText ?? headingTextInitial(t)}
            onChange={handleChangeTemplate('headingTextEditor')}
            defaultFontSize={FontSize.Medium}
            disabledFontFamily={isUserFreeOrBasicLimited}
            disabledColor={isUserFreeLimited}
            disabledFontSize={isUserFreeLimited}
            disabledEditor={isShowUpgradeNowRulePopup}
          />
        </BlockStack>
      </Card>

      <Card>
        <BlockStack gap="200">
          <BoldText>
            {t('pop_up_sub_heading')} {isShowUpgradeNowRulePopup && <CustomBadge />}
          </BoldText>
          <EditorCustom
            value={previewDetail?.subHeadingTextEditor ?? previewDetail?.subHeadingText ?? subHeadingTextInitial(t)}
            onChange={handleChangeTemplate('subHeadingTextEditor')}
            defaultFontSize={FontSize.Base}
            disabledFontFamily={isUserFreeOrBasicLimited}
            disabledColor={isUserFreeLimited}
            disabledFontSize={isUserFreeLimited}
            disabledEditor={isShowUpgradeNowRulePopup}
          />
        </BlockStack>
      </Card>
    </BlockStack>
  );
};

export default TextSetting;
